import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { X } from 'react-feather';
import NRRiseAiIcon from '../../../NRIcons/NRRiseAiIcon';

export default function DrawerHeader({ onClose }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: theme.spacing(8),
        borderBottom: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2, 3),
        backgroundColor: theme.palette.background.paper
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <NRRiseAiIcon height="24" width="24" color={theme.palette.riseAiPurple} />
        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
          RiseAI
        </Typography>
      </Box>
      <IconButton aria-label="Close" onClick={onClose} size="small">
        <X fontSize={16} />
      </IconButton>
    </Box>
  );
}
